import React, { Suspense } from 'react';

export const ArticlesComponent = React.lazy(() => import('./Articles'));

export const Articles = () => (
  <Suspense fallback={null}>
    <ArticlesComponent />
  </Suspense>
);
